import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#242526",
      d: "M9.173 8.002 5.44 4.268a.66.66 0 0 1-.195-.478.65.65 0 0 1 .195-.488.66.66 0 0 1 .483-.199q.284 0 .483.2l4.12 4.12a.76.76 0 0 1 .234.58.76.76 0 0 1-.234.58l-4.12 4.119a.66.66 0 0 1-.479.195.65.65 0 0 1-.487-.195.66.66 0 0 1-.2-.483q0-.284.2-.483z",
      class: "change-color-fill"
    }, null, -1)
  ]))]))
}
export default { render: render }